import { Box } from '@mui/material'
import { FormAdicionalNoturno } from './AdicionalNoturno'
import { BancoHoras } from './BancoHoras'
import CalculoAutomatico from './CalculoAutomatico'
import Digitacao from './Digitacao'
import IntegracaoFolha from './IntegracaoFolha'
import Justificativas from './Justificativas'

export const DadosPonto = () => {
    return (
        <Box component="section" id="dados-ponto">
            <BancoHoras />
            <FormAdicionalNoturno />
            <IntegracaoFolha />
            <CalculoAutomatico />
            <Justificativas />
            <Digitacao />
        </Box>
    )
}
